import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import SignaturePad from "signature_pad";

@Component({
  selector: 'ngx-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent implements OnInit, AfterViewInit{

  signatureNeeded!: boolean;
  signaturePad!: SignaturePad;
  @ViewChild('canvas') canvasEl!: ElementRef;
  @Input() signatureImg!: string;
  nameField: string;
  signaturePadContext : CanvasRenderingContext2D;
  inputboxClass: string;

  constructor() { }

  ngOnInit(): void {


  }
  ngAfterViewInit() {
    this.signaturePad = new SignaturePad
    (this.canvasEl.nativeElement,{throttle:5,dotSize:1,penColor:"black",minWidth:1, maxWidth:1});
    this.signaturePadContext = this.canvasEl.nativeElement.getContext('2d');
    this.nameField = "";
    this.inputboxClass = "ir-signature-pad";


  }

  startDrawing(event: Event) {

  }

  moved(event: Event) {

  }

  clearPad() {
    this.signaturePad.clear();
    this.nameField = "";
    this.inputboxClass = "ir-signature-pad";
  }
  no_backspaces(event)
  {
    const backspace = 8;
    const deleteCode = 46;
    if (event.keyCode === backspace || event.keyCode === deleteCode) event.preventDefault();
  }

  savePad() {
    const base64Data = this.signaturePad.toDataURL();
    this.signatureImg = base64Data;
    this.signatureNeeded = this.signaturePad.isEmpty();
    if (!this.signatureNeeded) {
      this.signatureNeeded = false;
    }
  }

  drawSignature() {
    this.inputboxClass = "ir-signature-pad-colorless";
    this.signaturePadContext.font = '40px Snell Roundhand, cursive';
    this.signaturePadContext.fillText(this.nameField, 65, 100);
    this.savePad();
  }

}
